import { GUI } from "dat.gui";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/tema6/Cards.glb";
import gsap from "gsap";

export class Cards extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(5, 5, 5)
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Spin = gltf.scene.getObjectByName("Spin", true);
			this.Puntos = gltf.scene.getObjectByName("Puntos", true);
			this.Ticket = gltf.scene.getObjectByName("Ticket", true);
		});
	}

	helpers() {
		const gui = new GUI();
		const folderCards = gui.addFolder("Cards");
		const limit = 20;
		folderCards.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderCards.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderCards.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderCards.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderCards.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderCards.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderCards.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderCards.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderCards.add(this, "visible").name("Visible");
	}
	insertCard() {
		this.clearAnimation()
		this.animation = gsap.to(this.position, {
			x: -10.6,
			duration: 0.5,
			delay: 1,
			ease: "none",
		});
	}
	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}
	}
}
